<template>
  <div class="content">
    <div class="content-main" style="position: relative">
      <p class="content-title">官方动态</p>
      <div class="editorInfo" @click="editEditorInfo()">
        <img :src="editorInfo.avatar" alt="" />
        <p>{{ editorInfo.nickName }}</p>
      </div>
      <div class="content-input">
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>置顶状态：</label>
          <el-select v-model="topState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in topStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
<!--        <div class="content-input-item">-->
<!--          <label>优质状态：</label>-->
<!--          <el-select v-model="qualityState" placeholder="Select" style="width: 8em">-->
<!--            <el-option v-for="item in qualityStateArray" :key="item.value" :label="item.label" :value="item.value">-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </div>-->
        <div class="content-input-item">
          <DatePickerRange title="创建时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
<!--        <div class="content-input-item">-->
<!--          <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType" :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" width="5em"/>-->
<!--        </div>-->
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)" :loading="searchLoading"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="primary" @click="editReleaseDialog(-1)">新建动态</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            @cell-click="toggleSelection"
            @selection-change="selsChange"
            @header-click="selsAll"
            border
        >
<!--          <el-table-column type="selection" width="55" align="center" class-name="cursor"/>-->
          <el-table-column property="createTime" label="创建时间" v-if="checkColList.indexOf('创建时间') > -1"/>
<!--          <el-table-column property="" label="头像" v-if="checkColList.indexOf('头像') > -1" class-name="cursor">-->
<!--            <template #default="scope">-->
<!--              <el-image style="width: 80px; height: 80px" :src="scope.row.portrait"><template #error><div class="el-img-error">暂无图片</div></template></el-image>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column property="msg" label="内容" v-if="checkColList.indexOf('内容') > -1" width="300"/>
          <el-table-column property="id" label="动态序号" v-if="checkColList.indexOf('动态序号') > -1"/>
          <el-table-column prop="" label="图片" v-if="checkColList.indexOf('图片') > -1" width="230">
            <template #default="scope">
              <el-space wrap>
                <div v-for="(item, index) in scope.row.zoneImgList" :key="item.id" class="imgItem">
                  <el-image style="width: 60px; height: 60px" fit="cover"  :src="item.smallImg" @click="showZoneImg(index, scope.row.zoneImgList)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
                  <div class="closeBtn" @click="delImg(item.id, scope.$index, index)">
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </div>
                </div>
              </el-space>
            </template>
          </el-table-column>
          <el-table-column property="topicName" label="话题" v-if="checkColList.indexOf('话题') > -1" ></el-table-column>
          <el-table-column property="" label="置顶状态" v-if="checkColList.indexOf('置顶状态') > -1" >
            <template #default="scope">
              {{scope.row.topState==0?'未置顶':scope.row.topState==1?'已置顶':scope.row.topState==2?'已过期':''}}
            </template>
          </el-table-column>
          <el-table-column prop="" label="置顶位置" v-if="checkColList.indexOf('置顶位置') > -1">
            <template #default="scope">
              {{scope.row.topType==0?'全部':scope.row.topType==1?'最新':scope.row.topType==2?'最热':scope.row.topType==3?'推荐':''}}
            </template>
          </el-table-column>
          <el-table-column prop="" label="置顶时间" v-if="checkColList.indexOf('置顶时间') > -1">
            <template #default="scope">
              <p>{{scope.row.topStartTime}}</p>
              <p>至</p>
              <p>{{scope.row.topEndTime}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="" label="消息推送" v-if="checkColList.indexOf('消息推送') > -1">
            <template #default="scope">
              {{scope.row.topPush==0?'不推送':scope.row.topPush==1?'推送':''}}
            </template>
          </el-table-column>
          <el-table-column prop="" label="状态" v-if="checkColList.indexOf('状态') > -1">
            <template #default="scope">
              {{scope.row.state==0?'待展示':scope.row.state==1?'已上架':scope.row.state==2?'已下架':''}}
            </template>
          </el-table-column>
          <el-table-column prop="" label="操作" v-if="checkColList.indexOf('操作') > -1">
            <template #default="scope">
              <el-space direction="vertical" alignment="left" :size="6">
                <el-button size="small" @click="editReleaseDialog(scope.$index,scope.row)" type="primary">编辑</el-button>
                <el-button type="success" size="small" @click="updateState(1, scope.row, scope.$index)" v-if="scope.row.state == 0 || scope.row.state == 2" v-loading="scope.row.updateLoading">上架</el-button>
                <el-button type="danger" size="small" @click="updateState(2, scope.row, scope.$index)" v-if="scope.row.state == 0 || scope.row.state == 1" v-loading="scope.row.updateLoading">下架</el-button>
              </el-space>
            </template>
          </el-table-column>
          <!--          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="200">-->
          <!--            <template #default="scope">-->
          <!--              <UserLog :user-log-list="scope.row.userLogList" />-->
          <!--            </template>-->
          <!--          </el-table-column>-->
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
import BtnGroup from '../../components/BtnGroup'
import ImgViewer from '../../assets/js/imageViewer'
import {
  getOfficialPageList, updateOfficialState, updateZoneImgDel, getOfficialInfo
} from '../../api/url'
import { getFormData, postJson, postFormData } from '../../api/api'
import Dialog from "@/assets/js/dialog";
import UserLogDialog from "@/components/UserLog/UserLogDialog";
import UserLog from "@/components/UserLog/UserLog";
import ImgUpload from "@/views/single/components/release/ImgUpload";
import OfficialReleaseDialog from "@/views/dynamic/components/OfficialReleaseDialog";
import EditorInfoDialog from "@/views/dynamic/components/EditorInfoDialog";

export default {
  name: "DynamicOfficial",
  components: { DatePickerRange, SearchComponents, BtnGroup, UserLog },
  data() {
    return {

      stateArray: [
        {label: '不限', value: -1},
        {label: '已上架', value: 1},
        {label: '已下架', value: 2},
      ],
      state: -1,

      // 发布状态
      topStateArray: [
        {label: '不限', value: -1},
        {label: '已置顶', value: 1},
        {label: '未置顶', value: 0},
        {label: '已过期', value: 2},
      ],
      topState: -1,

      // 优质状态
      qualityStateArray: [
        {label: '不限', value: -1},
        {label: '未设为优质', value: 0},
        {label: '已设为优质', value: 1},
        {label: '已取消优质', value: 2}
      ],
      qualityState: -1,


      //时间
      startTime: '',
      endTime: '',
      isChecked: true,


      //搜索
      searchTypeList: [
        {label : '昵称', value : 1}
      ],
      searchType: 1,
      searchValue: '',

      //刷新组
      colList: ['创建时间', '内容', '动态序号', '图片', '话题', '置顶状态', '置顶位置', '置顶时间', '消息推送', '状态', '操作'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      listLoading: false,
      searchLoading: false,
      bitchSetLoading: false,
      bitchUnsetLoading: false,
      bitchHideLoading: false,
      bitchForbidLoading: false,


      idArray: [],

      editorInfo: {},

    }
  },
  methods: {

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },

    getCheck(val) {
      this.isChecked = val
    },

    // getExpireTime(val) {
    //   this.startExpire = val[0];
    //   this.endExpire = val[1];
    //   // console.log(val)
    // },
    //
    // getExpireCheck(val) {
    //   this.isExpireChecked = val
    // },

    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.state = -1;
      this.topState = -1;
      // this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.id);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.id) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['state'] = this.state;
      param['topState'] = this.topState;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      // param['searchType'] = this.searchType;
      // param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getOfficialPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }
      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

      if(column.label == '头像') {
        Dialog.open({
          title: '上传头像图片',
          component: ImgUpload,
          data: {
            id: row.officialId,
            src: row.portrait,
            width: '400px'
          },
          close: () => {
            this.getPage()
          }
        })
      }

    },

    showImg(idx, list) {
      let imgList = []
      for(let i=0; i< list.length; i++) {
        imgList.push(list[i].img)
      }
      ImgViewer.open({
        imgList,
        imgIndex: idx
      })
    },

    updateState(state, row, idx) {
      this.$confirm('确认把序号为【' + row.id + '】的动态' + (state == 1?'【上架】':'【下架】') ).then(()=>{
        row.updateLoading = true
        let _this = this;
        let param = {};
        param['id'] = row.id
        param['state'] = state
        postFormData(updateOfficialState, param).then((data) => {
          let {code, msg} = data;
          if(code == 200) {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            row.state = state
          }else {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            });
          }
          row.updateLoading = false;
        })
            .catch(()=>{
              row.updateLoading = false;
            })
      })
    },



    editReleaseDialog(idx, row) {
      let _title = '';
      let releaseForm = Object.assign({}, row);
      if (idx > -1) {
        _title = '编辑'
      }else {
        _title = '新建'
      }
      Dialog.open({
        title: _title,
        component: OfficialReleaseDialog,
        data: {
          releaseForm: releaseForm,
          ids: idx,
        },
        confirm: (result) => {
          this.getPage()
        },
        close: () => {
          this.getPage()
        }
      })
    },


    showZoneImg(idx, list) {
      let imgList = []
      for(let i=0; i< list.length; i++) {
        imgList.push(list[i].img)
      }
      ImgViewer.open({
        imgList,
        imgIndex: idx
      })
    },

    delImg(id, zoneIndex, index) {
      let _this = this;
      this.$confirm('确定要删除图片？', {type: 'warning'}).then(() => {
        let param = {};
        param['id'] = id;
        param['zoneId'] = _this.pageDataList[zoneIndex]['id'];
        postFormData(updateZoneImgDel, param).then((data) => {
          let {code, msg} = data;
          if (code == 200) {
            _this.pageDataList[zoneIndex]['zoneImgList'].splice(index, 1);
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
          } else {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
        })
      }).catch(() => {
      })
    },

    getEditorInfo() {
      getFormData(getOfficialInfo).then((data) => {
        if(data.code == 200) {
          this.editorInfo = data.data;
        }
      })
    },

    editEditorInfo() {
      let _title = '编辑官方信息';
      Dialog.open({
        title: _title,
        component: EditorInfoDialog,
        data: {
          editorForm: this.editorInfo,
        },
        confirm: (result) => {
          this.getEditorInfo()
        }
      })
    }


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
    this.getEditorInfo()
  }
}
</script>

<style scoped>
.imgItem {
  position: relative;
}
.closeBtn {
  width: 2em;
  height: 2em;
  background-color: rgba(0,0,0,0.8);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0.6em;
}
.editorInfo {
  display: flex;
  align-items: center;
  background-color: #f6f6f6;
  padding: 0 12px;
  height: 34px;
  border-radius: 17px;
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
  font-size: 12px;
}
.editorInfo img {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  border-radius: 50%;
}
</style>
